import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import subscriptionImage from "../../../assets/staticImages/badge.png";
import { InputField, SubmitButton, TextComponent } from "../../../components";
import styles from "./Membership.module.css";
import Storage from "../../../utills/AsyncStorage";
import { PaymentMiddleware } from "../../../Store/Middlewares/PaymentMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const MembershipComp = ({ plan }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState();
  const [promoCode, setPromoCode] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const descriptionRef = useRef(null);

  const [apiData, setApiData] = useState(null);

  const isSubscribed = plan?.is_already_subscribed;

  const displayPrice = plan?.discounted_price
    ? plan?.discounted_price
    : plan?.price;
  const formattedPrice = Number(displayPrice).toFixed(2);

  const description = useMemo(
    () =>
      (plan?.description || "")
        .replace(/\r\n/g, "\n")
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean),
    [plan?.description],
  );

  useEffect(() => {
    const checkOverflow = () => {
      const el = descriptionRef.current;
      if (el && !expanded) {
        setIsOverflowing(el.scrollHeight > el.clientHeight);
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [description, expanded]);

  const handleSubscribe = () => {
    if (isSubscribed) {
      dispatch(
        showAlert({
          type: "Warning",
          message: "Already Subscribed",
        }),
      );
      return;
    }
    navigate("/paymentMethods", {
      state: {
        ...plan,
        discounted_price: apiData?.discounted_price
          ? apiData?.discounted_price
          : plan?.price,
        promo_code: promoCode ? promoCode : null,
      },
    });
  };

  const onHandleApplyPromoCode = (code) => {
    if (!code) {
      dispatch(
        showAlert({
          type: "Warning",
          message: "Please enter a promo code",
        }),
      );
    } else {
      let payload = {
        sub_id: plan?.id,
        code: code,
      };
      dispatch(PaymentMiddleware.ValidatePromoCode(payload)).then((res) => {
        setApiData(res);
      });
    }
  };

  console.log(" APi Data ===> ", apiData);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <img
          className={styles.badge}
          src={subscriptionImage}
          alt="Subscription plan"
        />
        <div className={styles.planTitle}>
          <TextComponent>{plan?.name}</TextComponent>
        </div>
      </div>

      {description.length > 0 && (
        <div className={styles.descriptionWrapper}>
          <p
            ref={descriptionRef}
            className={`${styles.description} ${
              expanded ? styles.descriptionExpanded : ""
            }`}
          >
            {description.join("\n")}
          </p>

          {(isOverflowing || expanded) && (
            <button
              type="button"
              className={styles.toggleBtn}
              onClick={() => setExpanded((prev) => !prev)}
            >
              {expanded ? "Show less" : "Show more"}
            </button>
          )}
        </div>
      )}

      <div className={styles.footer}>
        <div className={styles.priceContainer}>
          <div className={styles.priceRow}>
            <span className={styles.price}>
              $
              {apiData?.discounted_price
                ? apiData?.discounted_price
                : formattedPrice}
            </span>

            {apiData?.is_discount ? (
              <>
                <span className={styles.originalPrice}>
                  ${Number(apiData?.price).toFixed(2)}
                </span>
                {apiData?.type === "percentage" && (
                  <span className={styles.discountBadge}>
                    {apiData?.discount_percent}% OFF
                  </span>
                )}
              </>
            ) : (
              plan?.is_discount && (
                <>
                  <span className={styles.originalPrice}>
                    ${Number(plan?.price).toFixed(2)}
                  </span>
                  <span className={styles.discountBadge}>
                    {plan?.discount_percent}% OFF
                  </span>
                </>
              )
            )}
          </div>

          {plan?.is_discount && (
            <span className={styles.offerText}>
              Offer valid until{" "}
              {moment(plan?.discount_end_date).format("DD MMM YYYY")}
            </span>
          )}
        </div>

        {!plan?.is_discount && plan?.price > 0 && !apiData && (
          <div className={styles.promoContainer}>
            <InputField
              labelClass={styles.labelClass}
              label="Promo Code"
              placeholder="Enter promo code"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              innerInputClass={styles.inputField}
            />
            <SubmitButton
              title="Apply Promo Code"
              btnClass={styles.applyBtn}
              onClick={() => {
                onHandleApplyPromoCode(promoCode);
              }}
            />
          </div>
        )}

        <div className={styles.buttonWrap}>
          <SubmitButton
            title={isSubscribed ? "Currently Subscribed" : "Subscribe Now"}
            btnClass={styles.submitBtn}
            outline={true}
            onClick={handleSubscribe}
          />
        </div>
      </div>
    </div>
  );
};

const Membership = () => {
  const role = Storage.getERole("@role");
  const dispatch = useDispatch();

  const SubscriptionData = useSelector(
    (state) => state.PaymentReducer.allSubscriptions,
  );

  useEffect(() => {
    dispatch(PaymentMiddleware.getSubscriptions());
  }, [dispatch]);

  const plans = Array.isArray(SubscriptionData)
    ? SubscriptionData
    : SubscriptionData?.data || [];

  return (
    <div className={styles.membershipWrapper}>
      <Row justify="center" gutter={[24, 24]}>
        {plans.map((plan) => (
          <Col
            className={styles.col}
            xs={24}
            sm={24}
            md={role === "client" ? 18 : 12}
            lg={role === "client" ? 16 : 12}
            key={plan.id}
          >
            <MembershipComp plan={plan} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Membership;
